import inherited from 'mastodon/locales/io.json';

const messages = {
  //  No translations available.
};

export default Object.assign({}, inherited, messages);
